import { render, staticRenderFns } from "./Test_Widgets.vue?vue&type=template&id=c969a47a&scoped=true&lang=pug&"
import script from "./Test_Widgets.vue?vue&type=script&lang=js&"
export * from "./Test_Widgets.vue?vue&type=script&lang=js&"
import style0 from "./Test_Widgets.vue?vue&type=style&index=0&id=c969a47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c969a47a",
  null
  
)

export default component.exports